import React from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia?',
    a: 'No, está diseñado desde cero.'
  }, {
    q: '¿Funciona en departamentos?',
    a: 'Sí, especialmente pensado para eso.'
  }, {
    q: '¿Cuándo empiezo a ver resultados?',
    a: 'Puedes empezar en días y ver cambios en semanas.'
  }];
  return <section className="bg-neutral-bg py-10 px-4 sm:px-6 lg:px-8 border-t border-neutral-beige" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-center text-[#1A1A1A] mb-6" data-id="element-16">
          ❓ Preguntas frecuentes
        </h2>
        <div className="space-y-3" data-id="element-17">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl p-5 border border-neutral-beige shadow-sm hover:shadow-md transition-shadow" data-id="element-18">
              <h3 className="text-base font-black text-[#1A1A1A] mb-1 flex items-start" data-id="element-19">
                <span className="text-garden-medium mr-2" data-id="element-20">Q.</span>
                {faq.q}
              </h3>
              <p className="text-sm text-gray-600 font-medium pl-6 leading-relaxed" data-id="element-21">
                {faq.a}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}